<template>
    <label class="pull-right text" :for="labelFor" v-if="size > 0"></label>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: "HkepLabel",
        props: {
            labelFor: {
                default: null
            },
            size: {
                default: 0,
                type: Number
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HkepLabel.vue